<div class="component-container" [class.mini-cart]="isMiniCart">
    <div class="cart" [class.invalid]="!vm().product?.isAvailable">
        <div class="top">
            <div class="image" role="image" tabindex="-1" [ariaLabel]="vm().product.name">
                <lib-light-carousel
                    [images]="vm().smallImagesForCards"
                    [label]="vm().product.name"
                ></lib-light-carousel>
            </div>
            <div class="brand">
                <p class="label">{{ vm().product.brandName | uppercase }}</p>
                <p class="body-0">
                    <!-- RCP-306: engraving and AppleCare are not offered for the event, kept for later events.
                    @if (isProcessedProduct(vm().product) && hasEngraving(vm().product)) {
                        Personalized {{ vm().product.name }}
                    } @else {
                        {{ vm().product.name }}
                    }
                    -->
                    {{ vm().product.name }}
                </p>
                @if (vm().product?.estimatedShippingDays) {
                    <p class="body-1 shipping-info">
                        {{ vm().product.estimatedShippingDays }}
                    </p>
                }

                <!-- RCP-306: engraving and AppleCare are not offered for the event, kept for later events.
                @if (isOrderReview && isProcessedProduct(vm().product) && hasEngraving(vm().product)) {
                    <button
                        class="view-engraving-btn"
                        type="button"
                        [attr.aria-label]="'View engraving details for ' + vm().product.name"
                        (click)="viewEngravingDetails(vm().product)"
                    >
                        View details
                    </button>
                }
                -->
            </div>
            <div class="footer-part desktop">
                <div class="quantity">
                    @if (showControls) {
                        <div class="quantity-actions">
                            <lib-counter
                                [count]="vm().product.quantity ?? 1"
                                [hideButtons]="true"
                                [productName]="vm().product.name"
                            ></lib-counter>
                            <button
                                class="trash-btn"
                                type="button"
                                [attr.aria-label]="'Remove ' + vm().product.name + ' from cart'"
                                (click)="onRemove(vm().product.productId)"
                            >
                                <mat-icon svgIcon="ico_trash"></mat-icon>
                            </button>
                        </div>
                    } @else {
                        <p class="body-1">Quantity: {{ vm().product.quantity ?? 1 }}</p>
                    }
                </div>

                <div class="totals">
                    <span class="totals__price">
                        <p class="link">{{ formatPrice(vm().displayNewPrice) }}</p>
                    </span>

                    @if (vm().shouldShowOldPoints) {
                        <lib-cart-old-price [price]="vm().displayOldPrice" />
                    }
                </div>
            </div>
        </div>
        <div class="footer-part mobile">
            <div class="quantity">
                @if (showControls) {
                    <div class="quantity-actions">
                        <lib-counter
                            [count]="vm().product.quantity ?? 1"
                            [hideButtons]="true"
                            [productName]="vm().product.name"
                        ></lib-counter>
                        <button
                            class="trash-btn"
                            type="button"
                            [attr.aria-label]="'Remove ' + vm().product.name + ' from cart'"
                            (click)="onRemove(vm().product.productId)"
                        >
                            <mat-icon svgIcon="ico_trash"></mat-icon>
                        </button>
                    </div>
                } @else {
                    <p class="body-1">Quantity: {{ vm().product.quantity ?? 1 }}</p>
                }
            </div>

            <div class="totals">
                <span class="totals__price">
                    <p class="link">{{ formatPrice(vm().displayNewPrice) }}</p>
                </span>

                @if (vm().shouldShowOldPoints) {
                    <lib-cart-old-price [price]="vm().displayOldPrice" />
                }
            </div>
        </div>
        @if (!vm().product?.isAvailable) {
            <lib-alert-message
                text="This item is no longer available. Please remove it from your cart"
                type="error"
            ></lib-alert-message>
        }
        @if (limitMessage) {
            @if (isMiniCart) {
                <!-- Mini Cart: red triangle, no background (AC02) -->
                <lib-alert-message
                    class="limit-message"
                    iconOverride="ico_vector"
                    type="error"
                    variant="order-limit"
                    [text]="limitMessage"
                ></lib-alert-message>
            } @else {
                <!-- Cart page: grey bar, orange ring, dark text (AC05) -->
                <lib-alert-message
                    class="limit-message limit-message--bar"
                    iconSize="small"
                    type="warning"
                    typography="body-2"
                    [inline]="true"
                    [text]="limitMessage"
                ></lib-alert-message>
            }
        }
    </div>

    <!-- RCP-306: engraving and AppleCare are not offered for the event, kept for later events.
    Engraving Section Logic
    @if (engravingText()) {
        <div class="engraved-listing">
            <div class="content">
                <div class="icon">
                    <span class="engraved-icon">
                        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.95573 1.76251C5.2474 1.76251 1.41406 5.59168 1.41406 10.3042C1.41406 15.0167 5.2474 18.8458 9.95573 18.8458C14.6641 18.8458 18.4974 15.0125 18.4974 10.3042C18.4974 5.59585 14.6682 1.76251 9.95573 1.76251ZM9.95573 17.5958C5.9349 17.5958 2.66406 14.325 2.66406 10.3042C2.66406 6.28335 5.9349 3.01251 9.95573 3.01251C13.9766 3.01251 17.2474 6.28335 17.2474 10.3042C17.2474 14.325 13.9766 17.5958 9.95573 17.5958Z"
                                fill="#2E2E2E"
                            />
                            <path
                                d="M14.0193 7.99585H5.89844C5.5526 7.99585 5.27344 8.27502 5.27344 8.62085C5.27344 8.96668 5.5526 9.24585 5.89844 9.24585H14.0193C14.3651 9.24585 14.6443 8.96668 14.6443 8.62085C14.6443 8.27502 14.3651 7.99585 14.0193 7.99585Z"
                                fill="#2E2E2E"
                            />
                            <path
                                d="M13.1969 11.3625H6.73438C6.38854 11.3625 6.10938 11.6417 6.10938 11.9875C6.10938 12.3333 6.38854 12.6125 6.73438 12.6125H13.1969C13.5427 12.6125 13.8219 12.3333 13.8219 11.9875C13.8219 11.6417 13.5427 11.3625 13.1969 11.3625Z"
                                fill="#2E2E2E"
                            />
                        </svg>
                    </span>
                </div>
                <div class="details">
                    <h4>Engraved</h4>
                    @for (line of engravingLines(); track $index) {
                        <p class="engraving-line">{{ line }}</p>
                    }
                </div>
            </div>
            <div class="footer">
                <div class="pricing">
                    <div class="price">Free</div>
                </div>
                <a
                    class="action-link"
                    [class.disabled]="isEngravingActionDisabled()"
                    href="#"
                    (click)="!isEngravingActionDisabled() && onEditEngraving(); $event.preventDefault()"
                >
                    {{ getEngravingButtonText() }}
                </a>
                <a
                    class="action-link delete-engraving"
                    [class.disabled]="isEngravingActionDisabled()"
                    href="#"
                    (click)="!isEngravingActionDisabled() && onDeleteEngraving(); $event.preventDefault()"
                >
                    Delete
                </a>
            </div>
        </div>
    } @else if (shouldShowAddEngravingSection()) {
        <div class="add-engraving-listing">
            <div class="content">
                <div class="icon">
                    <span class="engraved-icon">
                        <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.95573 1.76251C5.2474 1.76251 1.41406 5.59168 1.41406 10.3042C1.41406 15.0167 5.2474 18.8458 9.95573 18.8458C14.6641 18.8458 18.4974 15.0125 18.4974 10.3042C18.4974 5.59585 14.6682 1.76251 9.95573 1.76251ZM9.95573 17.5958C5.9349 17.5958 2.66406 14.325 2.66406 10.3042C2.66406 6.28335 5.9349 3.01251 9.95573 3.01251C13.9766 3.01251 17.2474 6.28335 17.2474 10.3042C17.2774 14.325 13.9766 17.5958 9.95573 17.5958Z"
                                fill="#2E2E2E"
                            />
                            <path
                                d="M14.0193 7.99585H5.89844C5.5526 7.99585 5.27344 8.27502 5.27344 8.62085C5.27344 8.96668 5.5526 9.24585 5.89844 9.24585H14.0193C14.3651 9.24585 14.6443 8.96668 14.6443 8.62085C14.6443 8.27502 14.3651 7.99585 14.0193 7.99585Z"
                                fill="#2E2E2E"
                            />
                            <path
                                d="M13.1969 11.3625H6.73438C6.38854 11.3625 6.10938 11.6417 6.10938 11.9875C6.10938 12.3333 6.38854 12.6125 6.73438 12.6125H13.1969C13.5427 12.6125 13.8219 12.3333 13.8219 11.9875C13.8219 11.6417 13.5427 11.3625 13.1969 11.3625Z"
                                fill="#2E2E2E"
                            />
                        </svg>
                    </span>
                </div>
                <p class="body-0">Add engraving</p>
            </div>
            <div class="footer">
                <p class="body-0">Free</p>
                <a
                    class="action-link"
                    [class.disabled]="isEngravingActionDisabled()"
                    href="#"
                    (click)="!isEngravingActionDisabled() && onEditEngraving(); $event.preventDefault()"
                >
                    {{ getEngravingButtonText() }}
                </a>
            </div>
        </div>
    }
    -->

    <!-- RCP-306: engraving and AppleCare are not offered for the event, kept for later events.
    AppleCare Section
    @if (shouldShowAppleCareSection()) {
        <div class="apple-care-listing" [class.mini-cart]="isMiniCart" [class.order-review]="isOrderReview">
            SIMPLIFIED: Title shows only when AppleCare not added yet
            <h3
                class="body-0 applecare-listing-title"
                [class.d-none]="(appleCareItem?.isAdded ?? false) || !showControls"
            >
                Add AppleCare+
            </h3>

            <div class="content">
                <div class="logo">
                    <img
                        class="logo-image"
                        alt="AppleCare+"
                        src="https://maxsite.b-cdn.net/Chase/Apple/Icons/applecare/AppleCare_Icon.png"
                    />
                </div>

                <div class="details">
                    <p class="body-0 applecare-details-text">{{ appleCareItem?.productName ?? 'AppleCare+' }}</p>

                    SIMPLIFIED: Show pricing only when not added yet
                    <div class="pricing" [class.d-none]="(appleCareItem?.isAdded ?? false) || !showControls">
                        <p class="link applecare-details-text">{{ formatPrice(appleCareItem?.price ?? 0) }}</p>
                    </div>

                    <p class="body-2 applecare-details-text">Automatically registered with your Apple hardware.</p>

                    <div class="details-footer">
                        @if (!isOrderReview) {
                            <a
                                class="learn-more applecare-details-footer-link"
                                href="#"
                                (click)="onLearnMoreAppleCare(); $event.preventDefault()"
                            >
                                Learn more
                            </a>
                        }

                        SIMPLIFIED: Show add button only when not added
                        @if (!(appleCareItem?.isAdded ?? false)) {
                            <a
                                class="action-link applecare-details-footer-link"
                                [class.disabled]="isAppleCareActionDisabled()"
                                href="#"
                                (click)="!isAppleCareActionDisabled() && onAddAppleCare(); $event.preventDefault()"
                            >
                                {{ getAppleCareButtonText() }}
                            </a>
                        }
                    </div>
                </div>
            </div>

            Show footer when AppleCare is added
            @if (appleCareItem?.isAdded) {
                <div class="footer">
                    <div class="pricing">
                        REMOVED: Quantity label - always 1:1
                        <div class="price">
                            {{ formatPrice(appleCareItem?.price ?? 0) }}
                        </div>
                    </div>

                    @if (showControls) {
                        <a
                            class="action-link"
                            [class.disabled]="isAppleCareActionDisabled()"
                            href="#"
                            (click)="!isAppleCareActionDisabled() && onRemoveAppleCare(); $event.preventDefault()"
                        >
                            Remove AppleCare+
                        </a>
                    }
                </div>
            }
        </div>
    }
    -->
</div>
